import {
  addToPinBasket,
  confirmPayment,
  getAvailablePins,
  getPin,
  getPinBasket,
  getPinRegions,
  getPins,
  paymentCheck,
  removeFromPinBasket
} from './thunk';

export const pinBuilder = (builder: any) => {
  builder
    .addCase(getPins.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getPins.fulfilled, (state: any, action: any) => {
      state.pins = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getPins.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getPin.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getPin.fulfilled, (state: any, action: any) => {
      state.pin = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getPin.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getPinRegions.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getPinRegions.fulfilled, (state: any, action: any) => {
      state.pinRegions = action.payload.data?.regions || [];
      state.maxExpressDeliveryDistance = action.payload.data?.max_express_delivery_distance || null;
      state.polygonBoundaries = Array.isArray(action.payload.data?.polygon_boundaries)
        ? action.payload.data.polygon_boundaries
        : null;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getPinRegions.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getAvailablePins.pending, (state: any) => {
      // state.loading += 1;
      state.availablePinsLoading = true;
    })
    .addCase(getAvailablePins.fulfilled, (state: any, action: any) => {
      state.availablePins = action.payload.data;
      state.availablePinsLoading = false;
      // state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getAvailablePins.rejected, (state: any) => {
      state.availablePinsLoading = false;
      // state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getPinBasket.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getPinBasket.fulfilled, (state: any, action: any) => {
      state.pinBasket = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getPinBasket.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(addToPinBasket.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(addToPinBasket.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(addToPinBasket.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(removeFromPinBasket.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(removeFromPinBasket.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(removeFromPinBasket.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(paymentCheck.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(paymentCheck.fulfilled, (state: any, action: any) => {
      state.payment = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(paymentCheck.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(confirmPayment.pending, (state: any) => {
      state.confirmPaymentLoading = true;
    })
    .addCase(confirmPayment.fulfilled, (state: any) => {
      state.confirmPaymentLoading = false;
    })
    .addCase(confirmPayment.rejected, (state: any) => {
      state.confirmPaymentLoading = false;
    });
};
